import React from "react";
import { useLocation } from "react-router-dom";
import QPhototModuleSubtopic from "../../QPhotoModuleSubtopic";

const ALL_AI_SUBTOPICS = [
    { name: 'Introduction- Evolution of AI, State of Art - Types of AI', path: '/ai-m1-s1' },
    { name: 'Intelligent Agents- Structure of Intelligent Agents', path: '/ai-m1-s2' },
    { name: 'Environments and PEAS', path: '/ai-m1-s3' },
    { name: 'Introduction to Problem Solving by searching Methods-State Space search', path: '/ai-m2-s1' },
    { name: 'Uninformed Search Methods – Uniform Cost Search, Breadth First Search, Depth First Search, Depth-limited search, Iterative deepening depth-first', path: '/ai-m2-s2' },
    { name: 'Informed Search Methods- Best First Search, A* Search', path: '/ai-m2-s3' },
    { name: 'Local search algorithms - hill climbing search, simulated annealing, genetic algorithm', path: '/ai-m3-s1' },
    { name: 'Adversarial Search: Game Trees and Minimax Evaluation', path: '/ai-m3-s2' },
    { name: 'Elementary two-players games: tic-tac-toe, Minimax with Alpha-Beta Pruning', path: '/ai-m3-s3' },
    { name: 'Introduction to Logic and Reasoning-Propositional Logic', path: '/ai-m4-s1' },
    { name: 'First Order Logic-Inference in First Order Logic', path: '/ai-m4-s2' },
    { name: 'Unification, Forward Chaining, Backward Chaining, Resolution', path: '/ai-m4-s3' },
    { name: 'Quantifying Uncertainty', path: '/ai-m5-s1' },
    { name: 'Bayes Rule -Bayesian Belief Network', path: '/ai-m5-s2' },
    { name: 'Classical planning', path: '/ai-m6-s1' },
    { name: 'Planning as State-space search, Forward search, backward search', path: '/ai-m6-s2' },
    { name: 'Planning graphs, Hierarchical Planning', path: '/ai-m6-s3' },
    { name: 'Planning and acting in Nondeterministic domains – Sensor-less Planning, Multiagent planning', path: '/ai-m6-s4' },
    { name: 'Communication-Fundamentals of Language -Probabilistic Language Processing', path: '/ai-m7-s1' },
    { name: 'Information Retrieval- Information Extraction-Perception', path: '/ai-m7-s2' },
    { name: 'Image Formation- Object Recognition', path: '/ai-m7-s3' }
];

const AIModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_AI_SUBTOPICS, subjectPath = '/subject-AIModules' } = location.state || {};

    return (
        <QPhototModuleSubtopic
            title={title}
            videos={videos}
            pdfLink={pdfLink}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_AI_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default AIModuleSubtopic;
